<section class="emp-cart-sidebar p-3" [class.open]="isOpen()">
    @if(cartCookieService.cartValue().nrarticoli > 0) {
        <div class="emp-cart-items-header">
            <div class="emp-cart-title text-center">{{ 'headertop.cart' | T }}</div>

            <div class="emp-cart-items-footer text-left fw-bold">
                <span>{{ 'cart_tot' | T }} {{ totaleCarrello() | currency }}</span>
                <span class="badge rounded-pill bg-info text-dark badge-iva">{{ userStoreService.paga() | T }}</span>

                <div class="cart-tot-digest">{{ 'cart.item_nr' | T }} {{ cartCookieService.cartValue().articoli.length }}</div>
                <div class="cart-tot-digest">{{ 'cart.item_x_qty' | T }} {{ cartCookieService.nrArticoliXqta() }}</div>

                @if(!isMinPriceReached() && false) {
                    <app-min-price-alert></app-min-price-alert>
                }
                @else {
                    <!-- cta checkout -->
                    <div><button type="button" class="btn emp-checkout-btn emp-cta-primary-btn" routerLink="/checkout" (click)="closeSidebar()">CHECKOUT</button></div>
                    <!-- cta fast-checkout -->
                    @if(!userStoreService.isLoggedSignal() || userStoreService.isGuestSignal()) {
                        <div><button type="button" class="btn emp-fast-checkout-btn emp-cta-primary-btn" routerLink="/checkout/fast" (click)="closeSidebar()">{{ 'buy_without_registration' | T }}</button></div>
                    }
                }

            </div>

            <p class="emp-scroll-title">{{ 'articoli_in_carrello' | T }}</p>
        </div>
        <div class="emp-cart-items-scroller">
            @for(item of cartCookieService.cartValue().articoli; track item.item_id) {
                <div>
                    <figure>
                        <a class="emp-cart-anchor-wrap emp-cart-anchor-img" [routerLink]="['/p', item.seoname, item.item_id]">
                            <img src="{{ appConfig.imagePath() }}image1-{{ item.item_id }}.webp"  class="emp-cart-img img-fluid" alt="{{ item.descrizione }}" title="{{ item.descrizione }}">
                        </a>
                        <figcaption>
                            <a class="emp-cart-anchor-wrap" [routerLink]="['/p', item.seoname, item.item_id]">
                                {{ item.descrizione }}
                            </a>
                        </figcaption>
                    </figure>
                    <button class="emp-cart-btn emp-cart-decrement-btn" (click)="decrementItemQty(item.item_id)"><fa-icon [icon]="decrement_icon"></fa-icon></button>
                    <span class="fw-bold ps-2 pe-2">{{ item.item_quantita }}</span>
                    <button class="emp-cart-btn emp-cart-increment-btn" (click)="incrementItemQty(item.item_id)"><fa-icon [icon]="increment_icon"></fa-icon></button>
                    <button class="emp-cart-btn emp-cart-remove-btn" (click)="removeItem(item.item_id)"><fa-icon [icon]="delete_icon"></fa-icon></button>

                    <!-- <span class="emp-cart-item-price text-center ps-3 pe-3">{{ item.prezzo_privati_vat * item.item_quantita | currency }}</span> -->


                            <!-- non loggati vedono prezzoscontato (o prezzo privati vat) -->
                            @if(!userStoreService.isLoggedSignal()) {
                                <!-- prezzo di listino ?? STRANO CALCOLO ?? -->
                                @if(item.prezzo_listino - ((item.prezzo_listino*15)/100) >= item.prezzo_privati_vat) {
                                    <div class="prezzo-listino">{{ item.prezzo_listino | currency }}</div>
                                }
                                @else {
                                    <div class="prezzo-listino-fake">&nbsp;</div>
                                }

                                @if(appConfig.isComORcoUk()) {
                                    <span class="prezzo-scontato">{{ item.prezzo_privati_novat * item.item_quantita | currency }}</span>
                                }
                                @else {
                                    <span class="prezzo-scontato">{{ item.prezzo_privati_vat * item.item_quantita | currency }}</span>
                                }
                            }
                            @else {

                                    @if(appConfig.isComORcoUk()) {
                                        <!-- SOLO UK o COM -->
                                        @if(userStoreService.isProSignal()) {
                                            <!-- LOGGATI PRO -->
                                            <span class="prezzo-scontato">{{ item.prezzo_pro_novat * item.item_quantita | currency }}</span>
                                        }
                                        @else{
                                            <!-- LOGGATI NO PRO -->
                                            <span class="prezzo-scontato">{{ item.prezzo_privati_novat * item.item_quantita | currency }}</span>
                                        }
                                    }
                                    @else {
                                        <!-- ESCLUSI UK o COM -->
                                        @if(userStoreService.isProSignal()) {
                                            <!-- LOGGATI PRO -->
                                            <span class="prezzo-scontato">{{ item.prezzo_pro_novat * item.item_quantita | currency }}</span>
                                        }
                                        @else {
                                            <!-- LOGGATI NO PRO EXTRA UE -->
                                            @if(!userStoreService.isProSignal() && userStoreService.isEXTRAUE()) {
                                                <span class="prezzo-scontato">{{ item.prezzo_privati_novat * item.item_quantita | currency }}</span>
                                            }

                                            <!-- LOGGATI NO PRO UE -->
                                            @if(!userStoreService.isProSignal() && !userStoreService.isEXTRAUE()) {
                                                <span class="prezzo-scontato">{{ item.prezzo_privati_vat * item.item_quantita | currency }}</span>
                                            }
                                        }
                                    }



                            }

                    <hr>
                </div>
            }
        </div>
    }
    @else {
        <app-cart-empty></app-cart-empty>
    }
</section>